const FOON_SITE_MODE = process.env.REACT_APP_SITE;

export const isStandaloneFoonSite = FOON_SITE_MODE === "foon";

const FOON_BASE_PATH = isStandaloneFoonSite ? "" : "/foon";

export const buildFoonPath = (path = "") => {
  if (!path || path === "/") {
    return FOON_BASE_PATH || "/";
  }

  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${FOON_BASE_PATH}${normalizedPath}` || "/";
};

export const isFoonHeadPath = (pathname) =>
  pathname === buildFoonPath("/foon-head");
